import { create } from 'zustand'
import { persist, createJSONStorage } from 'zustand/middleware'
import type { AudienceFilters } from '@brushfire/types'
import type { SignalProviderVerifiedFilter } from '@/features/signal-providers/lib/signal-provider-list-filters'

const STORAGE_KEY = 'brushfire-signal-provider-list-filters'

interface SignalProviderListFiltersState {
  demographicFilters: AudienceFilters
  verifiedFilter: SignalProviderVerifiedFilter
  setDemographicFilters: (filters: AudienceFilters) => void
  setVerifiedFilter: (filter: SignalProviderVerifiedFilter) => void
  clearDemographicFilters: () => void
  reset: () => void
}

const initialState = {
  demographicFilters: {} as AudienceFilters,
  verifiedFilter: 'all' as SignalProviderVerifiedFilter,
}

export const useSignalProviderListFiltersStore = create<SignalProviderListFiltersState>()(
  persist(
    (set) => ({
      ...initialState,
      setDemographicFilters: (demographicFilters) => set({ demographicFilters }),
      setVerifiedFilter: (verifiedFilter) => set({ verifiedFilter }),
      clearDemographicFilters: () => set({ demographicFilters: {} }),
      reset: () => set(initialState),
    }),
    {
      name: STORAGE_KEY,
      storage: createJSONStorage(() => sessionStorage),
      partialize: (state) => ({
        demographicFilters: state.demographicFilters,
        verifiedFilter: state.verifiedFilter,
      }),
    },
  ),
)

export function resetSignalProviderListFilters(): void {
  useSignalProviderListFiltersStore.getState().reset()
}
